import { IntakeFormFromQuery } from 'api/crm/intakeFormAPI';

const crmAdapter = {
  /**
   * Temporary fix until backend updates the format of
   * supplementaryQuestions templates. Removes the "{0} - " prefix.
   */
  fetchAndStoreIntakeForm: (response: {
    clientIntakeSubmission: IntakeFormFromQuery;
  }): { clientIntakeSubmission: IntakeFormFromQuery } => {
    const SUPPLEMENTARY_QUESTION_IDENTIFIER = 'supplementaryQuestions';
    const TEMPLATE_PREFIX = '{0} - ';
    const { fieldIssues } = response.clientIntakeSubmission;

    const updatedFieldIssues = Object.entries(fieldIssues).reduce(
      (acc, [key, value]) => {
        if (
          key.includes(SUPPLEMENTARY_QUESTION_IDENTIFIER) &&
          value.fieldTemplate?.template
        ) {
          const parts = value.fieldTemplate.template.split(TEMPLATE_PREFIX);
          const cleanedTemplate =
            parts.length > 1 ? parts[1] : value.fieldTemplate.template;

          acc[key] = {
            ...value,
            fieldTemplate: {
              ...value.fieldTemplate,
              template: cleanedTemplate,
            },
          };
        } else {
          acc[key] = value;
        }

        return acc;
      },
      {} as typeof fieldIssues,
    );

    return {
      clientIntakeSubmission: {
        ...response.clientIntakeSubmission,
        fieldIssues: updatedFieldIssues,
      },
    };
  },
};

export { crmAdapter };
